import { Button } from '@wot/components';
import { ITutor } from '@wot/typings';
import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import categoryApi from '../../api/categories';
import { BACK_ARROW } from '../../assets/icons';
import { CAUTION } from '../../assets/images';
import TutorCard from '../../components/TutorCard';
import { SEO } from '../../components/SEO';

function SearchResults() {
  const { query } = useParams();
  const navigate = useNavigate();
  const [, setLoading] = useState(false);
  const [tutorsList, setTutorsList] = useState<ITutor[]>([]);

  useEffect(() => {
    setLoading(true);
    categoryApi
      .getSearchResults(query!)
      .then((data) => {
        setTutorsList(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [query]);

  return (
    <>
    <SEO 
      title={query ? `Search: ${query} - WorldoTutor` : 'Search Tutors - WorldoTutor'}
      description={query ? `Search results for "${query}" on WorldoTutor. Find expert tutors matching your search.` : 'Search for tutors on WorldoTutor.'}
      keywords={query ? `search, ${query}, tutor, online tutor, find tutor` : 'search tutors, find tutor, online tutoring search'}
      url={query ? `/search/${query}` : '/search'}
      type="website"
      og={{
        type: 'website',
        siteName: 'WorldoTutor',
        locale: 'en_US',
        image: {
          url: '/imgi_1_favicon.png',
          alt: 'Search Tutors - WorldoTutor',
          width: 1200,
          height: 630
        }
      }}
      twitter={{
        card: 'summary_large_image',
        site: '@worldotutor',
        image: {
          url: '/imgi_1_favicon.png',
          alt: 'Search Tutors - WorldoTutor'
        }
      }}
    />
    <div className="w-full bg-[#F5F6F9]">
      <div className="container mx-auto">
        <div className="hidden md:flex gap-3 py-5">
          <div
            className="w-8 h-8 flex items-center justify-center bg-neutralBlue2 rounded-full cursor-pointer drop-shadow-md"
            onClick={() => navigate(-1)}
          >
            <img src={BACK_ARROW} alt="Go Back" />
          </div>
        </div>
        <div className="md:bg-white flex flex-col gap-8 p-5 rounded">
          <h2 className="text-2xl font-semibold">Find a Tutor</h2>
        </div>
        {/* <div className="bg-neutralGray4 flex justify-end py-7 relative">
          <span
            className="flex mx-4 text-base font-medium cursor-pointer "
            onClick={() => setFilterSortOpt(!filterSortOpt)}
          >
            Filter
            <img src={ARROW_DOWN_BLACK} alt="arrDown" />
          </span>
          {filterSortOpt && <FilterSortMenu />}
        </div> */}
        <div className="bg-white flex flex-col p-3 gap-2">
          {tutorsList.length > 0 ? (
            <div className="grid 2xl:grid-cols-4 xl:grid-cols-4 sm:grid-cols-2 grid-cols-1">
              {tutorsList.map((item: any, index: any) => (
                <TutorCard item={item} key={index} />
              ))}
            </div>
          ) : (
            <>
              <div className="flex flex-col gap-5 items-center py-10">
                <img src={CAUTION} alt="No results found" className="rounded-full" />
                <div className="flex flex-col items-center w-full gap-2">
                  <span className="text-2xl font-medium">Oops,</span>
                  <span className="w-full text-lg font-normal text-center">No trainers found.</span>
                </div>
                <div className="max-w-[200px]">
                  <Link to="/post-requirement">
                    <Button text="Post a Requirement" onClick={() => { }} size="lg" />
                  </Link>
                </div>
              </div>
            </>
          )}
          {/* <div className="flex w-full items-center justify-between py-2 px-3 bg-white border">
            <div className="flex items-center gap-4">
              <p className="text-sm font-semibold text-ellipsis text-left text-gray-900">
                {`${currentPage} of ${Math.ceil(total / resultsPerPage)} pages`}
              </p>
              <button
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
                className={`border-2 rounded-sm ${
                  currentPage === 1 ? 'opacity-40' : 'opacity-100'
                } font-semibold p-2 text-xs flex items-center justify-center`}
              >
                Prev
              </button>
              <button
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage >= Math.ceil(total / resultsPerPage)}
                className={`border-2 rounded-sm ${
                  currentPage >= Math.ceil(total / resultsPerPage) ? 'opacity-40' : 'opacity-100'
                } font-semibold  p-2 text-xs flex items-center justify-center`}
              >
                Next
              </button>
            </div>
            <p className="text-sm font-semibold">{total} Results found.</p>
          </div> */}
          {/* <div className="py-2">
              {tutorsList.length > 8 && (
                <Button
                  text="View All"
                  textColor="text-white"
                  bgColor="bg-secondary"
                  borderColor="border-secondary"
                  onClick={() => {}}
                />
              )}
            </div> */}
        </div>
      </div>
      <div className="bg-primary flex flex-col items-center py-4 mt-10 gap-3">
        <span className="text-white text-base font-medium text-center">
          Do you need help in finding the best teacher matching your requirements?
        </span>
        <div>
          <Link to="/post-requirement">
            <Button text="Post Your Requirement" onClick={() => { }} />
          </Link>
        </div>
      </div>
    </div>
    </>
  );
}

export default SearchResults;
